<div class="d-flex justify-content-center h-100 mb-0 background-white z-max">
    <form>
        <div class="login-container p-5">
            <div class="row mb-3 mt-3 text-center">
                <img alt="logo"
                     src="https://cdn.prod.website-files.com/5d71f4ee972e97f69dafbc67/5e58ffd7bda4713ada470db5_logo--black.svg"
                     width="225px">
            </div>
            <div class="d-flex justify-content-end">Version: {{ appVersion }}</div>
            <div class="form-group">
                <input
                    [(ngModel)]="uid"
                    autocomplete="username"
                    autocapitalize="off"
                    class="height-50px mb-2 form-control {{uid() == undefined || uid() == '' ? '' : uid() != undefined ? 'is-valid' : 'is-invalid'}}"
                    datatype="text"
                    id="uid"
                    name="uid"
                    placeholder="Username"
                    type="text">
                <input
                    [(ngModel)]="password"
                    autocomplete="current-password"
                    autocapitalize="off"
                    class="height-50px mb-2 form-control {{password() == undefined || password() == '' ? '' : password() != undefined ? 'is-valid' : 'is-invalid'}}"
                    datatype="text"
                    id="password"
                    name="password"
                    placeholder="Password"
                    type="password">
            </div>
            <app-generic-button 
                (click)="signIn()"
                description="Sign in"
                [alwaysShowText]="true"
                [attr.type]="'submit'"
                [buttonClass]="'btn-info'"
                [buttonText]="'Sign-in'"
                [disabled]="loading() || uid() == undefined || password() == undefined"
                [loading]="loading()"
                [primaryIcon]="'fa-solid fa-right-to-bracket'"
                class="w-100"/>
            <div class="text-center mt-3">
                <a class="text-decoration-none color-primary-information"
                   href="https://www.flaticon.com/authors/freepik"
                   title="icons-attribution">Icons by Freepik - Flaticon
                </a>
            </div>
            <div class="text-center mt-3">
                @let error = errorMessage();

                @if (error) {
                    <div class="w-100">
                        <div class="card text-center">
                            <div class="d-flex align-items-center p-3 text-danger gap-1">
                                <i class="fa fa-xl fa-exclamation-triangle primary-warn"></i>
                                {{ error }}
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
</div>
